<div [ngClass]="{ 'mb-2': showLabel }">
    <label *ngIf="showLabel" for="igAccountDropdown" class="block mb-1 text-sm font-medium">
        Conta do Instagram
    </label>

    <!-- SKELETON ENQUANTO CARREGA -->
    <p-skeleton *ngIf="displayDialogAguarde" height="40px" styleClass="w-full mb-2"></p-skeleton>

    <ng-container *ngIf="!displayDialogAguarde">
        <ng-container *ngIf="useAppendToBody; else defaultDropdown">
            <p-dropdown inputId="igAccountDropdown" [options]="dropdownOptions"
                [(ngModel)]="dropdownSelectedValue" optionLabel="label" optionValue="value"
                [class.p-0]="!noDropdownClass" [class.ss-l-pdrop-feeds]="!noDropdownClass" appendTo="body"
                [disabled]="disabled"
                placeholder="Selecione uma conta do Instagram" (onChange)="onSelectInstagramAccount($event.value)">
                <ng-template let-option pTemplate="item">
                    <div class="flex align-items-center">
                        <ng-container *ngIf="option.value !== 'add_account'; else addIcon">
                            <img [src]="option.picture" width="18" height="18" class="mr-2 border-circle" />
                            <div class="flex flex-column">
                                <span>{{ option.label }}</span>
                                <span *ngIf="option.pageName" class="text-xs text-500">Página: {{ option.pageName }}</span>
                            </div>
                        </ng-container>
                        <ng-template #addIcon>
                            <i class="pi pi-plus mr-2"></i>
                            <span>{{ option.label }}</span>
                        </ng-template>
                    </div>
                </ng-template>

                <ng-template let-option pTemplate="selectedItem">
                    <div class="flex align-items-center">
                        <ng-container *ngIf="option.value !== 'add_account'; else addIconSelected">
                            <img [src]="option.picture" width="18" height="18" class="mr-2 border-circle" />
                            <div class="flex flex-column">
                                <span>{{ option.label }}</span>
                                <span *ngIf="option.pageName" class="text-xs text-500">Página: {{ option.pageName }}</span>
                            </div>
                        </ng-container>
                        <ng-template #addIconSelected>
                            <i class="pi pi-plus mr-2"></i>
                            <span>{{ option.label }}</span>
                        </ng-template>
                    </div>
                </ng-template>
            </p-dropdown>
        </ng-container>

        <ng-template #defaultDropdown>
            <p-dropdown inputId="igAccountDropdown" [options]="dropdownOptions"
                [(ngModel)]="dropdownSelectedValue" optionLabel="label" optionValue="value"
                [class.p-0]="!noDropdownClass" [class.ss-l-pdrop-feeds]="!noDropdownClass"
                [disabled]="disabled"
                placeholder="Selecione uma conta do Instagram" (onChange)="onSelectInstagramAccount($event.value)">
                <ng-template let-option pTemplate="item">
                    <div class="flex align-items-center">
                        <ng-container *ngIf="option.value !== 'add_account'; else addIcon">
                            <img [src]="option.picture" width="18" height="18" class="mr-2 border-circle" />
                            <div class="flex flex-column">
                                <span>{{ option.label }}</span>
                                <span *ngIf="option.pageName" class="text-xs text-500">Página: {{ option.pageName }}</span>
                            </div>
                        </ng-container>
                        <ng-template #addIcon>
                            <i class="pi pi-plus mr-2"></i>
                            <span>{{ option.label }}</span>
                        </ng-template>
                    </div>
                </ng-template>

                <ng-template let-option pTemplate="selectedItem">
                    <div class="flex align-items-center">
                        <ng-container *ngIf="option.value !== 'add_account'; else addIconSelected">
                            <img [src]="option.picture" width="18" height="18" class="mr-2 border-circle" />
                            <div class="flex flex-column">
                                <span>{{ option.label }}</span>
                                <span *ngIf="option.pageName" class="text-xs text-500">Página: {{ option.pageName }}</span>
                            </div>
                        </ng-container>
                        <ng-template #addIconSelected>
                            <i class="pi pi-plus mr-2"></i>
                            <span>{{ option.label }}</span>
                        </ng-template>
                    </div>
                </ng-template>
            </p-dropdown>
        </ng-template>
    </ng-container>
</div>